// WGS 84 constants describing the shape of the earth
export const EQUATOR_CIRCUMFERENCE_M = 6_378_137 * Math.PI * 2;
export const MERIDIAN_CIRCUMFERENCE_M = 6_356_752 * Math.PI * 2;
export type Point = [number, number];

/** Meters per degree of latitude and longitude at a given latitude. */
export const metersPerDegree = (
  latDegrees: number
): { lat: number; lng: number } => ({
  lat: MERIDIAN_CIRCUMFERENCE_M / 360,
  lng: (EQUATOR_CIRCUMFERENCE_M * Math.cos(latDegrees * (Math.PI / 180))) / 360,
});

/**
 * Projects points from a local offset to gps coordinates. Typically used when for rendering objects on a map.
 * Points should be in meters.
 */
export const projectPolygonOntoGlobe = (
  points: Point[],
  headingDegrees: number,
  centerLat: number,
  centerLng: number
): Point[] => {
  // Rotate to face tractor heading
  const headingRadians = -headingDegrees * (Math.PI / 180);
  const cosHeading = Math.cos(headingRadians);
  const sinHeading = Math.sin(headingRadians);
  points = points.map(([x, y]) => {
    return [cosHeading * x - sinHeading * y, sinHeading * x + cosHeading * y];
  });

  // Project onto globe
  const scale = metersPerDegree(centerLat);
  return points.map(([x, y]) => {
    return [centerLng + x / scale.lng, centerLat + y / scale.lat];
  });
};
